
@switch (!!listing?.models?.length) {
  @case (true) {
    <div class="wrap center p-b-0-s">
      <p class="o1 m-t-6 m-t-8-s">
        {{topCopy | uppercase}}
      </p>
      <h1 class="h1 p-t-5 p-b-1">{{name}}
      </h1>
    </div>

    <!-- sticky filters -->
    <sticky-free class="pos-relative"
                  [stickyId]="'listing-filters'"
                  [isStickyDownOffset]="100">
        <div class="m-t-7 m-t-0-s pe-none">
          <div class="pe-auto listing-filters__inner">
            <div class="pos-relative center z-3 bg-col-w">
              <ng-container *ifSize="'!S'">
                <div class="p-t p-b"
                  dragScroll>
                  @for (option of navigationItems; track option; let first = $first; let i = $index) {
                    <ng-container
                      *ngTemplateOutlet="navOptionTmpl; context: { $implicit: option, first : first}">
                    </ng-container>
                  }
                </div>
              </ng-container>
              <!-- tags on mobile -->
              <ng-container *ifSize="'S'">
                <button type="button"
                  class="m-t-3 m-b-3 p-b-2 b-b b-col-1 p-l-3 p-r-3"
                  zippyToggle="filter">
                  <span class="s1">{{ currentCategoryName }}</span>
                  <i class="m-l-2 va-m icon-arrow-down"
                    [style.font-size.rem]="0.8"
                    zippyName="filter"
                  zippyClass="icon-arrow-up"></i>
                </button>
                <div
                  class="blog-filters-body pos-absolute left-50 bg-col-w hide-up-container w-11 box-shadow-1">
                  <div class="ng-hide-animate ng-hide hide-up p-t overflow-y-auto custom-scrollbar flex flex-column flex-justify-cneter"
                    zippy="filter"
                    style="max-height: 57vh;">
                    @for (option of navigationItems; track option; let first = $first) {
                      <ng-container
                        *ngTemplateOutlet="navOptionTmpl; context: { $implicit: option, first : first}">
                      </ng-container>
                    }
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
    </sticky-free>

    <!-- main listing area -->
    <div class="pos-relative">
      <div class="bg-col-51">
        <div class="center wrap p-b-10 p-t-10 m-t-7 p-t-4-s p-b-3-s">
          <div [grid]="[1, 2, 4, 4][client.sizeId]"
            [gridColumnGap]="[0, 4, 4, 4][client.sizeId]"
            [gridRowGap]="[8, 5, 5, 5][client.sizeId]">
            @for (model of listing.models; track model; let isFirst = $first; let isLast = $last) {
              <cms-blog-content-blog-card [model]="model"
                class="bg-col-w block"
                >
              </cms-blog-content-blog-card>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- show more button -->
    @if (listing?.hasMore) {
      <div class="flex flex-justify-center bg-col-51 p-t p-b-10"
        >
        <action class="button-1"
          (click)="listing.increaseLimit()">
          <span>{{'View more' | translate}}</span>
        </action>
      </div>
    }
  }
  <!-- no posts to display -->
  @default {
    <div class="p-t p-b center">{{'No posts to display' | translate}}</div>
  }
}

<ng-template let-option
  let-first="first"
  #navOptionTmpl>
  @switch (!!typeData.tagRedirect) {
    <!-- links for tag-redirect mode -->
    @case (true) {
      <a [routerLink]="option.url"
        >
        <ng-container *ngTemplateOutlet="navOptionInnerTmpl; context: { $implicit: option, first : first}">
        </ng-container>
      </a>
    }
    <!-- simple filter output for non redirect case -->
    @case (false) {
      <ng-container *ngTemplateOutlet="navOptionInnerTmpl; context: { $implicit: option, first : first}">
      </ng-container>
    }
  }
</ng-template>

<!-- inner template with list item -->
<ng-template let-option
  let-first="first"
  #navOptionInnerTmpl>
  <button type="button"
    class="block-s s1 p-b-1 p-b-4-s m-l-7 m-r-7 m-l-0-s m-r-0-s"
    [ngClass]="isSelected(option) ? app.client.isS ? 'col-1' : 'b-b b-col-1': 'col-12'"
    [style.border-width.px]="1.5"
    zippyClose="filter"
  (click)="selectNav(option)">{{option.name}}</button>
</ng-template>
